<div style="max-width: 1700px; margin: 0 auto;">
  <ng-container *ngIf="basicData">
    <div class="container grand-container multitable-container">
      <div class="p-card" style="padding: 0.2rem;">
  
        <div *ngIf="report.reportDetails.reportType == reportType.REPORTE_ATENCION_EVENTOS" class="p-card">
          <div class="subtable-title mb-2">
            <div style="width: 50%; min-width: 50%;">
              <div style="padding: 20px;">
                {{report.reportDetails.periodRange}}
              </div>
            </div>
            <div >
              <div style="padding: 20px;">
                <button class="btn btn-gl btn-gl-light-blue btn-dark-hover" (click)="actualizarEvaluacionEventos();" >ACTUALIZAR</button>
              </div>
            </div>
            <div>
              <div style="padding: 20px;">
                <button class="btn btn-gl btn-gl-light-blue btn-dark-hover" (click)="guardarEvaluacionEventos();" >GUARDAR</button>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="report.reportDetails.reportType != reportType.REPORTE_ATENCION_EVENTOS"  class="subtable-title mb-3">
          <div>
            <div>PERIODO</div>
            <div>{{report.reportDetails.periodRange}}</div>

          </div>
        </div>
  
  
        <app-report-table
          [columns]="columns"
          [rows]="basicData.records"
          [type]="tableType"
          [report]="report"
          [scrollHeight]="'calc(100vh - var(--report-table-scrollOffset))'"
        >
        </app-report-table>
      </div>
    </div>
  </ng-container>
</div>